import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "acknowledge" }
const _hoisted_2 = { class: "jumbotron" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "display-4" }, "Acknowledge", -1)
const _hoisted_4 = { class: "lead" }

import { ref, onMounted, inject } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { Booking } from '@/models';

// No props defined for this component


export default /*#__PURE__*/_defineComponent({
  __name: 'Acknowledge',
  setup(__props) {

const store = useStore();
const route = useRoute();
const message = ref('');

// Convert Actions
const updateDataentryAcknowledge = async (bookingid: string): Promise<any> => {
  await store.dispatch('diary/updateDataentryAcknowledge', bookingid);
};

const updateReportDataentryStatus = async (payload: { id: string | undefined; status: string }): Promise<any> => {
  await store.dispatch('reports/updateReportDataentryStatus', payload);
};

const getBooking = async (payload: { id: string; cancelled: string }): Promise<Booking> => {
  return await store.dispatch('diary/getBookingWithoutStoringInState', payload);
};

// Converted mounted lifecycle hook
onMounted(async () => {
  const routeId = (route.params.id as string);
  if (routeId) {
    await updateDataentryAcknowledge(routeId);
    getBooking({ id: routeId, cancelled: 'false' })
      .then((booking: Booking) => {
        if (booking?.dataentryreport?.id) {
          updateReportDataentryStatus({ id: booking.dataentryreport.id, status: 'Acknowledged' });
        }
      });
    message.value = 'Thank you for confirming';
  } else {
    message.value = 'No booking id provided!';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, _toDisplayString(message.value), 1)
    ])
  ]))
}
}

})